import {
  Calendar as StableCalendar,
  CalendarProps as StableCalendarProps,
} from "../../../components";
import { CalendarBetaPropsContext } from "./CalendarBetaPropsContext";

export interface CalendarBetaProps {
  dateMetadata?: {
    date: string;
    context: string;
  }[];
  onMonthView?: ({ month, year }: { month: number; year: number }) => void;
}

export const Calendar = (props: CalendarBetaProps & StableCalendarProps) => {
  const { dateMetadata, onMonthView, ...stableProps } = props;
  return (
    <CalendarBetaPropsContext.Provider value={{ dateMetadata, onMonthView }}>
      <StableCalendar {...stableProps} />
    </CalendarBetaPropsContext.Provider>
  );
};
